import React, { useEffect, useState } from "react";
import saveAs from "file-saver";
import axios from 'axios'; // npm i axios
import { Navbar, Row, Col, Offcanvas } from 'react-bootstrap';
import Conexao from '../../Config/conexao';
import { excel } from "react-export-table-to-excel/lib/lib";
import { TryRounded } from "@mui/icons-material";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from 'react-bootstrap/Button';
import { Link, Redirect } from 'react-router-dom';
import VariavelGlobal from '../../Config/Variavelglobal'
import { Container, ContainerForm, TextFieldStyled } from "./styles";
//import '../RDO/Rdo.css'


function Cadastro_Furo(props) {

    const [sonda, setSonda] = useState([])



    const [processo, setProcesso] = useState("")
    const [cliente, setCliente] = useState("")
    const [obra, setObra] = useState("")
    const [cidade, setCidade] = useState("")

    const [furo, setFuro] = useState("")
    const [inclinacao, setInclinacao] = useState("")
    const [azimute, setAzimute] = useState("")
    const [alvo, setAlvo] = useState("")

    const [showSobreSidebar, setShowSobreSidebar] = useState(false);

    const [habilitar, setHabilitar] = useState(true)
    const [bnthabilitar, setBnthabilitar] = useState("true")

    const [setorLogado, setSetorLogado] = useState();
    const [setorDoCargo, setSetorDoCargo] = useState();
    const [nivelDoCargo, setNivelDoCargo] = useState();
    const [showSidebar, setShowSidebar] = useState(false);

    const [listaProcesso, setListaProcesso] = useState([]);
    const [liClicked1, setLiClicked1] = useState(false);
    const [liClicked, setLiClicked] = useState(false);
    const [show, setShow] = useState(false);
    function handleClose() { setShow(false) }
    const handleShow = () => setShow(true);

    const [show1, setShow1] = useState(false);
    function handleClose1() { setShow1(false) }
    const handleShow1 = () => setShow1(true);

    function carregaUser() { setSetorLogado(localStorage.usuario) };
    useEffect(() => { carregaUser() }, []);

    async function getNivel() {
        const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
        if (res.data.success === false) {
            //  setLoading(false)
            //  falha();  
        } else {

            if (res.data.nivel === "Gerente") {
                setHabilitar(false)
                setBnthabilitar(false)
                VariavelGlobal.ButtonEnable = false
                console.log("Nivel_Dentro  " + res.data.nivel);
                console.log("Usuario  " + setorLogado);
            } else {
                if (res.data.nivel === "Supervisor") {
                    setHabilitar(false)
                    setBnthabilitar(false)
                    VariavelGlobal.ButtonEnable = false
                } else {
                    setHabilitar(true)
                    setBnthabilitar(true)
                    VariavelGlobal.ButtonEnable = true
                }
            }

        }
    };
    const handleCloseSidebar = () => {
        setShowSidebar(false);
      
      }
    function LIMPAR() {

        setSonda([])

        setCliente("")
        setObra("")
        setCidade("")
        setFuro("")
        setInclinacao("")
        setAzimute("")
        setAlvo("")
    }


    async function BuscarProcesso() {
        console.log('buscaRDO', processo)
        const res = await axios.get(Conexao.api + 'ListaProjetoParaSondagem.php?processo=' + processo);


        if (res.data.success === true) {
            setCliente(res.data.result[0].cliente)
            setObra(res.data.result[0].obra)
            setCidade(res.data.result[0].cidade)


            setHabilitar(false)
            setBnthabilitar(false)
            VariavelGlobal.ButtonEnable = false
            getNivel()

        } else {

            VariavelGlobal.ButtonEnable = true
            LIMPAR()
            setHabilitar(false)
            setBnthabilitar(false)

            alert('Cadastro NÃO REALIZADO')
        }
        console.log('retornobusca RDO', res.data.result)



    };

    async function BuscarCadastro() {

        const res = await axios.get(Conexao.api + 'ListaCadastroFuroPesquisaMineral.php?processo=' + processo);


        if (res.data.success === true) {
            setCliente(res.data.result[0].cliente)
            setObra(res.data.result[0].obra)
            setCidade(res.data.result[0].cidade)
            setFuro(res.data.result[0].sondagem)
            setInclinacao(res.data.result[0].inclinacao)
            setAzimute(res.data.result[0].azimute)
            setAlvo(res.data.result[0].alvo)
            setSonda(res.data.result[0].sonda)


            setHabilitar(false)
            setBnthabilitar(false)
            VariavelGlobal.ButtonEnable = false
            getNivel()

        } else {

            BuscarProcesso()
            BuscarSonda()
        }
        console.log('retornobusca RDO', res.data.result)



    };



    async function BuscarSonda() {

        const res = await axios.get(Conexao.api + 'ListaSondaParaSondagem.php?sonda=' + "");

        if (res.data.success) {
            setSonda(res.data.result)


        } else {

            setSonda([])

        }

        console.log('SONDAS  ' + res.data.result)
        console.log('SONDAS2  ' + sonda)
    };


    async function BuscarProcessos() {

        const res = await axios.get(Conexao.api + 'ListaProcessosPesquisaMineralWEB.php');

        if (res.data.false) {


        }
        else { setListaProcesso(res.data.result); }

    };

    useEffect(() => { BuscarProcessos() })



    async function SalvarCadastro() {
        const obj = {
            processo, cliente, obra, cidade, furo, inclinacao, azimute, alvo, sonda
        };

        const res = await axios.post(Conexao.api + 'SalvarCadastroFuroPesquisaMineral.php', obj);

        console.log('SalvarLista', obj)

        if (res.data.success === true) {
            alert('Cadastro Atualizado Sucesso!')
        }


    };

    const handleShowSidebar = (index) => {
        setShowSidebar(true);
        //setBackgroundImage(images[index]);

    }

    const handleLiClickSobre = (index) => {
       
        setLiClicked1(true);
        setShowSobreSidebar(true);
     
      };




    return (<div className="home">
        <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1300px', minWidth: '1400px' }} >
        <div className="sidebar-button">
                <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
                    <div className="icon-container">
                        <i className="bi bi-list icon-circle"></i>
                    </div>
                </Button>

            </div>
            <div className="language-buttons"style={{marginRight:'0%' }}>
                <Button variant="outline" className="rounded-circle">
                    <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
                </Button>
                <Button variant="outline" className="rounded-circle">
                    <img src="../Images/BandeiraPortugal.png" alt="Português" />
                </Button>
            </div>
            <div className="sidebar-Text">
                <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '10%', }}>Cadastro Nova Sondagem</text>
            </div>
            <Container>
                <ContainerForm>
                   



                    <body class="container text-center ">

                        <div class="container text-center ">
                            <div class="row d-flex align-items-end justify-content-center p-2">

                                <div class="col-md-3 md-0">

                                    <h6>Processo:</h6>
                                    <input list='ListaProcessos' name='processo' id='processo' className='form-control text-center' value={processo} onChange={(e) => setProcesso(e.target.value)} ></input>
                                    <datalist id="ListaProcessos">
                                        {/*  {listaProcesso.map((e) => ( <option key={e.id} > {e.Processo} </option> ))}  */}

                                        {[...new Set(listaProcesso.map(e => e.Processo))].map((Processo, index) => (
                                            <option key={index}>{Processo}</option>
                                        ))}
                                    </datalist>

                                    <div className="col-12 d-flex justify-content-center">
                                        <div className="btn " type="submit">
                                            <button onClick={(e) => BuscarCadastro(e)} className="btnlogin me-md-2">Buscar</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </body>

                    <form className="container-fluid ">
                        <br />
                        <br />

                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">

                                    <br />
                                    <div class="col-4">
                                        <h7>Cliente:</h7>
                                        <input name='cliente' id='cliente' className='form-control text-center colorInput ' disabled={habilitar} value={cliente} onChange={(e) => setCliente(e.target.value)} ></input>
                                    </div>

                                    <div class="col-4">
                                        <h7>Projeto:</h7>
                                        <input name='obra' id='obra' className='form-control text-center colorInput ' disabled={habilitar} value={obra} onChange={(e) => setObra(e.target.value)} ></input>
                                    </div>


                                    <div class="col-4">
                                        <h7>Municipio:</h7>
                                        <input name='cidade' id='cidade' className='form-control text-center colorInput ' disabled={habilitar} value={cidade} onChange={(e) => setCidade(e.target.value)} ></input>
                                    </div>

                                </div>
                            </div>
                        </body>
                        <br />



                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">



                                    <div class="col-6">
                                        <h7>Sondagem N:</h7>
                                        <input name='sondagem' id='sondagem' className='form-control text-center colorInput ' disabled={habilitar} value={furo} onChange={(e) => setFuro(e.target.value)} ></input>
                                    </div>

                                    <div class="col-6">
                                        <h7>Inclinação 0 a 90:</h7>
                                        <input name='inclinacao' id='inclinacao' className='form-control text-center colorInput ' disabled={habilitar} value={inclinacao} onChange={(e) => setInclinacao(e.target.value)} ></input>
                                    </div>

                                </div>
                            </div>
                        </body>

                        <br />

                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">


                                    <div class="col-6">
                                        <h7>Azimute 0 a 360:</h7>
                                        <input name='azimute' id='azimute' className='form-control text-center colorInput ' disabled={habilitar} value={azimute} onChange={(e) => setAzimute(e.target.value)} ></input>
                                    </div>

                                    <div class="col-6">
                                        <h7>Alvo:</h7>
                                        <input name='alvo' id='alvo' className='form-control text-center colorInput ' disabled={habilitar} value={alvo} onChange={(e) => setAlvo(e.target.value)} ></input>
                                    </div>


                                </div>
                            </div>
                        </body>

                        <br />

                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">

                                    <div class="col">
                                        <h6> SONDA</h6>
                                        <select disabled={habilitar} onChange={(e) => setSonda(e.target.value)} value={sonda} className='borda form-select text-center   '>
                                            <option value='Selecione'>Selecione</option>
                                            <option value='GEO 113 - EPIROC BOYLES C5C'>GEO 113 - EPIROC BOYLES C5C</option>
                                            <option value='GEO 119 - EPIROC BOYLES C5C'>GEO 119 - EPIROC BOYLES C5C</option>
                                            <option value='GEO 120 - EPIROC CS140C'>GEO 120 - EPIROC CS140C</option>
                                            <option value='GEO 122 - EPIROC BOYLES C6C'>GEO 122 - EPIROC BOYLES C6C</option>
                                            <option value='GEO 126 - EPIROC BOYLES C6C'>GEO 126 - EPIROC BOYLES C6C</option>
                                            <option value='GEO 134 - EPIROC BOYLES C6C'>GEO 134 - EPIROC BOYLES C6C</option>
                                            <option value='GEO 135 - BOART LONGYEAR LF90'>GEO 135 - BOART LONGYEAR LF90</option>
                                            <option value='GEO 136 - COMACCHIO CX2020'>GEO 136 - COMACCHIO CX2020</option>
                                            <option value='GEO 137 - BOART LONGYEAR LF90'>GEO 137 - BOART LONGYEAR LF90</option>
                                            <option value='GEO 138 - BOART LONGYEAR LF90'>GEO 138 - BOART LONGYEAR LF90</option>
                                            <option value='GEO 139 - EPIROC BOYLES C6C'>GEO 139 - EPIROC BOYLES C6C</option>
                                            <option value='GEO 140 - EPIROC BOYLES C6C'>GEO 140 - EPIROC BOYLES C6C</option>
                                            <option value='GEO 141 - DELTA MAKINA D150'>GEO 141 - DELTA MAKINA D150</option>
                                            <option value='GEO 142 - DELTA MAKINA D150'>GEO 142 - DELTA MAKINA D150</option>


                                        </select>
                                    </div>




                                </div>
                            </div>
                        </body>

                        <br />
                        <br />
                        <body  >
                            <div class="container text-center">
                                <div class="row align-items-start">




                                </div>
                            </div>
                        </body>
                        <br />
                        <br />
                       

                    </form>



    
                

                    <div className="col-12 d-flex justify-content-center">
                        <div className="btn " type="submit">
                            <button onClick={(e) => (SalvarCadastro(e))} class="btnlogin  me-md-2  " hidden={bnthabilitar} Button > Salvar </button>
                        </div>
                    </div>











                </ContainerForm>


            </Container>
            <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
        <div className="offcanvas-header">
  
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
                
        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
              <Link to="/app/PesquisaMineral_Inicio"style={{ textDecoration: 'none' }}>
              <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto',fontSize:'20px' }}>Menu</button></Link>
            </li>
           
            
            <div className="offcanvas-footer">
                    <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
                        <Link to="/#" style={{ textDecoration: 'none' }}>
                            <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Sair</button>
                        </Link>
                    </li>
                </div>
            {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
        </div>


    </div>
    )



}

export default Cadastro_Furo;